import { render, staticRenderFns } from "./ModalDatosPaciente.vue?vue&type=template&id=29ccad8c&scoped=true"
import script from "./ModalDatosPaciente.vue?vue&type=script&lang=js"
export * from "./ModalDatosPaciente.vue?vue&type=script&lang=js"
import style0 from "./ModalDatosPaciente.vue?vue&type=style&index=0&id=29ccad8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ccad8c",
  null
  
)

export default component.exports